import { obiSources, tySources, atticusSources } from './assets';

import type { ReviewCardProps } from './ReviewCard';

export const reviewsData: ReviewCardProps[] = [
  {
    quote: `Obi had terrible allergies. We tried everything. After switching to The Farmer’s Dog he doesn’t have one single hot spot, and he doesn’t lick his paws chronically anymore. He also has a bunch of energy.`,
    author: 'Obi’s mom',
    sources: obiSources,
    alt: 'Obi',
  },
  {
    quote: `As soon as we brought The Farmer’s Dog home, her skin was better, she was more active (and high quality poops!). If I can invest in her health and be proactive I think it’s worth it.`,
    author: 'Tyene’s dad',
    sources: tySources,
    alt: 'Tyene',
  },
  {
    quote: `Atticus had bad gas and diarrhea. I just thought it was part of having a big dog. With The Farmer’s Dog, it was a complete 180. I should have known that what you put in your body makes a huge difference.`,
    author: 'Atticus’ mom',
    sources: atticusSources,
    alt: 'Atticus',
  },
];
